export interface IProfileState {
  name: string,
  email: string,
  language: SelectableLanguages,
}
export const registeredLanguages = ['da-DK', 'en-GB', 'en-US', 'de-DE', 'sv-SE', 'nl-NL', 'nb-NO', 'it-IT']
export type SelectableLanguages = typeof registeredLanguages[number];;
